"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildStringTemplate = void 0;
var template_1 = __importDefault(require("lodash/template"));
/**
 * Build string from template and data from lodash: https://lodash.com/docs/#template
 * @param template string template. example: 'hello <%= name %>'
 * @param data data objects that interpolate to template. example: { name: 'David'}
 * @return string example: 'hello David'
 */
function buildStringTemplate(stringTemplate, data) {
    var compiled = (0, template_1.default)(stringTemplate);
    return compiled(data);
}
exports.buildStringTemplate = buildStringTemplate;
//# sourceMappingURL=string-template.js.map